var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-tip"},[_c('div',{staticClass:"icon-wrapper"},[_c('img',{attrs:{"src":require(("@/assets/" + _vm.iconPath))}})]),_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }